import { IResponseBaseTDto } from "@sprytki-frontend-apps/common";
import { ITokenResponseData } from "api/interfaces/auth";
import { LoginValues } from "api/interfaces/login";
import { clearStorage, getUserDataFromAccessToken } from "shared";
import { storageKeys } from "shared/constants";
import { apiClient } from "./apiClient";

export const ApiService = {
	refresh: async (refreshToken: string, userName?: string, ignoreResponseInterceptor: boolean = false): Promise<IResponseBaseTDto<ITokenResponseData>> => {
		const response = await apiClient.post<IResponseBaseTDto<ITokenResponseData>>('auth/login/refresh', {
			refreshToken,
			userName
		},
		ignoreResponseInterceptor ? {
			headers:{ "X-Skip-Response-Interceptor": "true" }
		} : undefined);
		return response.data;
	},
	checkApkVersion: async (): Promise<void> => {
		await apiClient.get<void>('auth/checkApkVersion');
	},
	login: async ({
		userName,
		password, rememberMe }: LoginValues
	): Promise<IResponseBaseTDto<ITokenResponseData>> => {
		const response = await apiClient.post<IResponseBaseTDto<ITokenResponseData>>('auth/login', { userName, password });
		if (response.data.success) {
			const storage = rememberMe ? localStorage : sessionStorage
			rememberMe && storage.setItem(storageKeys.REMEMBER_ME, rememberMe.toString())

			storage.setItem(storageKeys.ACCESS_TOKEN, response.data.data.accessToken)
			storage.setItem(storageKeys.REFRESH_TOKEN, response.data.data.refreshToken)
			const userName = getUserDataFromAccessToken(response.data.data.accessToken)?.userName as string
			storage.setItem(storageKeys.USER_NAME, userName)

			clearStorage([storageKeys.ACCESS_TOKEN, storageKeys.REFRESH_TOKEN, storageKeys.USER_NAME], rememberMe ? 'session' : 'local')
		}
		return response.data
	}
}
